export default {
	path: '/speaker-ai-config',
	redirect: '/speaker-ai-config',
	component: () => import('@/views/layout/Default'),
	children: [
		{
			path: '/',
			name: 'speakerAiConfigHome',
			component: () => import('@/views/mng/SpeakerAiConfig'),
		},
	],
};
